export function formatBytes(size: number): string {
  if (size < 1024) return `${size} o`;
  if (size < 1024 * 1024) return `${(size / 1024).toFixed(1)} Ko`;
  if (size < 1024 * 1024 * 1024) return `${(size / (1024 * 1024)).toFixed(1)} Mo`;
  return `${(size / (1024 * 1024 * 1024)).toFixed(2)} Go`;
}

export function relativeTime(iso: string | null): string {
  if (!iso) return "jamais";
  const delta = Date.now() - Date.parse(iso);
  if (!Number.isFinite(delta)) return "jamais";
  const seconds = Math.max(0, Math.round(delta / 1000));
  if (seconds < 15) return "à l'instant";
  if (seconds < 60) return `il y a ${seconds} s`;
  const minutes = Math.round(seconds / 60);
  if (minutes < 60) return `il y a ${minutes} min`;
  const hours = Math.round(minutes / 60);
  if (hours < 48) return `il y a ${hours} h`;
  return `il y a ${Math.round(hours / 24)} j`;
}

export function pairingCode(code: string | null | undefined): string {
  const digits = (code ?? "").replace(/\D/g, "");
  if (digits.length !== 6) return "——";
  return `${digits.slice(0, 3)} ${digits.slice(3)}`;
}

export function durationLabel(seconds: number | null, type: "video" | "image"): string {
  if (seconds === null) return type === "video" ? "vidéo entière" : "10 s";
  return `${seconds} s`;
}

export function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean).slice(0, 2);
  const value = parts.map((part) => part[0]?.toUpperCase() ?? "").join("");
  return value || "AF";
}
